import * as T from './eodClickhouseConstants';
import type {
  EodSummaryReportPayload,
  EodSummaryReportNormalised,
} from '../../../interface/eodClickhouseInterface';

// ── EOD Summary Report ──────────────────────────────────────────────────────

export const fetchEodSummaryReportRequest = (payload: EodSummaryReportPayload) => ({
  type: T.FETCH_EOD_SUMMARY_REPORT_REQUEST as typeof T.FETCH_EOD_SUMMARY_REPORT_REQUEST,
  payload,
});

export const fetchEodSummaryReportSuccess = (data: EodSummaryReportNormalised) => ({
  type: T.FETCH_EOD_SUMMARY_REPORT_SUCCESS as typeof T.FETCH_EOD_SUMMARY_REPORT_SUCCESS,
  payload: data,
});

export const fetchEodSummaryReportFailure = (error: string) => ({
  type: T.FETCH_EOD_SUMMARY_REPORT_FAILURE as typeof T.FETCH_EOD_SUMMARY_REPORT_FAILURE,
  payload: { error },
});

// ── EOD Funds table (same endpoint, own page / size / sort state) ───────────

export const fetchEodFundsReportRequest = (payload: EodSummaryReportPayload) => ({
  type: T.FETCH_EOD_FUNDS_REPORT_REQUEST as typeof T.FETCH_EOD_FUNDS_REPORT_REQUEST,
  payload,
});

export const fetchEodFundsReportSuccess = (data: EodSummaryReportNormalised) => ({
  type: T.FETCH_EOD_FUNDS_REPORT_SUCCESS as typeof T.FETCH_EOD_FUNDS_REPORT_SUCCESS,
  payload: data,
});

export const fetchEodFundsReportFailure = (error: string) => ({
  type: T.FETCH_EOD_FUNDS_REPORT_FAILURE as typeof T.FETCH_EOD_FUNDS_REPORT_FAILURE,
  payload: { error },
});

export type EodClickhouseAction =
  | ReturnType<typeof fetchEodSummaryReportRequest>
  | ReturnType<typeof fetchEodSummaryReportSuccess>
  | ReturnType<typeof fetchEodSummaryReportFailure>
  | ReturnType<typeof fetchEodFundsReportRequest>
  | ReturnType<typeof fetchEodFundsReportSuccess>
  | ReturnType<typeof fetchEodFundsReportFailure>;
